<template>
  <v-row dense no-gutters>
    <v-col v-for="(item,i) in items" :cols="cols" :key="i">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>{{formData[item.code]}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ['formData'],
  data () {
    return {
      cols: 4,
      items: [
        { title: '企业名称', code: 'unitName' },
        { title: '税号', code: 'taxNo' },
        { title: '费用名称', code: 'subjectName' },
        { title: '地址电话', code: 'addressTel' },
        { title: '收方姓名', code: 'rcvName' },
        { title: '收方联系电话', code: 'rcvPhone' },
        { title: '收方地址', code: 'rcvAddr' },
        { title: '收方邮编', code: 'rcvZipCode' }
      ]
    }
  }
}
</script>